// native
import { Component, Input, OnChanges } from "@angular/core";

@Component({
  selector: 'progress-bar',
  templateUrl: './progress-bar.component.html'
})
export class ProgressBarComponent implements OnChanges {
  @Input() progress: number;

  percentage: string;

  ngOnChanges() {
    this.percentage = this.progress + '%';
  }
}
